import * as XLSX from 'xlsx';
import { writeFile } from 'xlsx-color';

const getFormattedDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};

const addBorders = (sheet, range) => {
  const borderStyle = {
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
    }
  };

  for (let row = range.s.r; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
      if (!sheet[cellRef]) continue;
      sheet[cellRef].s = { ...sheet[cellRef].s, ...borderStyle };
    }
  }
};

export const formatGoalDescription = (description) => {
  const maxLength = 150;
  if (description.length <= maxLength) {
    return description;
  } else {
    const firstLine = description.substring(0, maxLength);
    const secondLine = description.substring(maxLength);
    return `${firstLine}\n${secondLine.trim()}`;
  }
};

export const downloadExcel = (supplierData, fileName) => {
  const wb = XLSX.utils.book_new();
  const suppliersSheet = XLSX.utils.json_to_sheet(supplierData);

  const goalsRange = XLSX.utils.decode_range(suppliersSheet['!ref']);
  const headerStyle = {
    font: { bold: true, sz: 12 },
    fill: { fgColor: { rgb: 'c4c3d0' } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
  };

  for (let C = goalsRange.s.c; C <= goalsRange.e.c; ++C) {
    const cellRef = XLSX.utils.encode_cell({ c: C, r: 0 });
    if (!suppliersSheet[cellRef]) continue;
    suppliersSheet[cellRef].s = headerStyle;
  }

  addBorders(suppliersSheet, goalsRange);

  suppliersSheet['!cols'] = [
    { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 },
    { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 },
    { wch: 30 }, { wch: 30 }, { wch: 30 } 
  ];

  const underlineStyle = {
    alignment: { wrapText: true },
    border: {
      bottom: { style: 'thin', color: { rgb: '000000' } }
    }
  };

  const numberOfRows = supplierData.length;

  suppliersSheet['!rows'] = [];

  for (let i = 1; i <= numberOfRows; i++) {
    const goalDescriptionCell = `E${i + 1}`;
    let rowHeight = 24;
    const descriptionText = suppliersSheet[goalDescriptionCell]?.v || '';
    if (descriptionText.length > 50) {
      rowHeight = 30;
    }

    suppliersSheet['!rows'].push({ hpt: rowHeight });

    if (suppliersSheet[goalDescriptionCell]) {
      suppliersSheet[goalDescriptionCell].s = underlineStyle;
    }
  }

  XLSX.utils.book_append_sheet(wb, suppliersSheet, fileName);
  const timestamp = getFormattedDate();
  const file = `${fileName}_${timestamp}.xlsx`;
  writeFile(wb, file);
};


export const downloadDashboardExcel = (recycleData, carbonAvoidedData, cdpData, goalsData) => {
  const year= new Date().getFullYear();
  const lyemission=cdpData.emissionsByYear[year-1]
  const wsData = [];
  console.log(lyemission);
  

  wsData.push(["SUSTAINABILITY REPORT"]);
  wsData.push([]);
  wsData.push(["Summary"]);
  wsData.push(["Metric", "Current Year", "Previous Year", "% Change"]);

  const dataRows = [
    ["Recyclable Packaging", recycleData?.recyclablePackaging || 0, recycleData?.lyRecyclablePackaging || 0, (recycleData?.percentChangedRecyclablePackaging || 0)/100],
    ["Carbon Emission Avoided", carbonAvoidedData?.totalEmissionAvoided || 0, carbonAvoidedData?.lyTotalEmissionAvoided || 0, carbonAvoidedData?.percentageChanged/100 || 0],
    ["CDP Data", cdpData?.totalCarbonemission || 0, lyemission || 0, cdpData?.yoY/100 || 0],
    ["Supplier Count", goalsData?.tySupplierCount || 0, goalsData?.lySupplierCount || 0, goalsData?.supplierCountPercentageChange/100 || 0]
  ];

  wsData.push(...dataRows);
  wsData.push([]);

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  const titleStyle = {
    font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1F415B" } },
    alignment: { horizontal: "center", vertical: "center" },
    border: {
      top: { style: "medium", color: { rgb: "1F415B" } },
      bottom: { style: "medium", color: { rgb: "1F415B" } },
      left: { style: "medium", color: { rgb: "1F415B" } },
      right: { style: "medium", color: { rgb: "1F415B" } }
    }
  };

  const sectionHeaderStyle = {
    font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "4F81BD" } },
    alignment: { horizontal: "left", vertical: "center" },
    border: {
      top: { style: "thin", color: { rgb: "4F81BD" } },
      bottom: { style: "thin", color: { rgb: "4F81BD" } },
      left: { style: "thin", color: { rgb: "4F81BD" } },
      right: { style: "thin", color: { rgb: "4F81BD" } }
    }
  };

  const tableHeaderStyle = {
    font: { bold: true, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "305496" } },
    alignment: { horizontal: "center", vertical: "center" },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const dataStyle = {
    alignment: { horizontal: "center", vertical: "center" },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const percentStyle = {
    numFmt: "0.0%",
    alignment: { horizontal: "center", vertical: "center" },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const safelyApplyStyle = (sheet, cellAddress, style) => {
    if (!sheet[cellAddress]) {
      sheet[cellAddress] = { t: 's', v: '' };
    }
    sheet[cellAddress].s = style;
  };

  // Apply styles
  safelyApplyStyle(ws, "A1", titleStyle);
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
    { s: { r: 2, c: 0 }, e: { r: 2, c: 3 } }
  ];
  safelyApplyStyle(ws, "A3", sectionHeaderStyle);

  ["A4", "B4", "C4", "D4"].forEach(cell => safelyApplyStyle(ws, cell, tableHeaderStyle));

  // Loop over data rows and apply styles
  for (let i = 0; i < dataRows.length; i++) {
    const rowIndex = 5 + i;
    ["A", "B", "C"].forEach((col) => safelyApplyStyle(ws, `${col}${rowIndex}`, dataStyle));
    safelyApplyStyle(ws, `D${rowIndex}`, percentStyle);
  }

  ws['!cols'] = [
    { wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dashboard");
  writeFile(wb, `Sustainability_Dashboard_${getFormattedDate()}.xlsx`);
};
